import { render, staticRenderFns } from "./AmendSignPwd.vue?vue&type=template&id=575430d2"
import script from "./AmendSignPwd.vue?vue&type=script&lang=js"
export * from "./AmendSignPwd.vue?vue&type=script&lang=js"
import style0 from "./AmendSignPwd.vue?vue&type=style&index=0&id=575430d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports